/* eslint-disable */
function Placeholder() {
    const placeholders = document.querySelectorAll(".placeholder");
    placeholders.forEach(placeholder => {
        const input = placeholder.previousElementSibling;
        const status = () => {
            if (input.value.length <= 0) {
                placeholder.classList.remove("hide");
            }
        }
        input.addEventListener("focus", () => placeholder.classList.add("hide"));
        input.addEventListener("blur", status);
        input.addEventListener("change", status);
    })

    this.show = () => {
        placeholders.forEach(placeholder => placeholder.classList.remove("hide"))
    }

    this.hide = () => {
        placeholders.forEach(placeholder => placeholder.classList.add("hide"))
    }

}
export default Placeholder;
